import { actionPhotos } from "./products";

export { actionPhotos };

export const products = [
  {
    id: "PWGCDBJJ02C",
    slug: "rush-ls",
    shopUrl: "https://carpediembjj.store/products/phg-cdbjj-rush-g-l-s",
    name: "PHG x CDBJJ RASH.G L/S",
    category: "RASH GUARD L/S",
    price: 9800,
    material: "ポリエステル100%",
    tagline: "今を生きる哲学が、長袖の一枚に宿る。",
    description:
      "more than jiu-jitsu — Live the Discipline Active Collection。\n道着の下でも、ノーギのマットでも──柔術家の鍛錬の時間に密着する長袖ラッシュガード。ポリエステル100%の速乾スキンタイト設計が、スパーリングセッション中の余計な意識を排除する。長袖がマットバーンとスウィープ時の摩擦から腕全体を守りながら、袖口が一切の動作を妨げない。\n\nCarpe Diem（今を生きる）──纏うたびに、自分の哲学が身体を通して表れる。",
    features: ["道着インナー対応", "マットバーン防止", "速乾スキンタイト", "ノーギ対応"],
    colors: [
      {
        label: "BLACK",
        image: "/images/3.jpg",
      },
      {
        label: "GRAY",
        image: "/images/8.jpg",
      },
    ],
    image: "/images/3.jpg",
    sizeHeaders: ["サイズ", "着丈 (cm)", "身幅 (cm)", "袖丈 (cm)", "体重目安 (kg)"],
    sizeRows: [
      ["S", "63", "40", "67", "50〜60"],
      ["M", "66", "42", "69", "60〜70"],
      ["L", "69", "44", "72", "70〜80"],
      ["XL", "71", "45", "74", "80〜90"],
      ["XXL", "73", "47", "78", "90〜100"],
    ],
    sizeNote: "体重目安は標準体型を基準。筋量多め・肩幅広めの方は1サイズアップを推奨。",
  },
  {
    id: "PWGCDBJJ03C",
    slug: "rush-ss",
    shopUrl: "https://carpediembjj.store/products/powerhouse-gym-carpe-diem-s-s-rash-guard",
    name: "PHG x CDBJJ RASH.G H/S",
    category: "RASH GUARD H/S",
    price: 8800,
    material: "ポリエステル100%",
    tagline: "技の精度だけが残る。柔術家のための半袖。",
    description:
      "more than jiu-jitsu — Live the Discipline Active Collection。\n半袖設計が肩から肘への可動域を完全に開放し、アームドラッグ、シングルレッグ、タックルエントリーの一連の動作を妨げない。ポリエステル100%の速乾素材がロール中の蒸れを排除し、道着の下に着ればバルクを最小化する。スキンタイトフィットが余分な布地を消し去り、グラップリングの精度だけが残る。\n\nCarpe Diem──セッションを重ねるたびに、その哲学が深まる。",
    features: ["肩〜肘フリー可動", "道着インナー対応", "速乾ドライ", "グラップリング精度向上"],
    colors: [
      {
        label: "BLACK",
        image: "/images/A1_5399.jpg",
      },
      {
        label: "GRAY",
        image: "/images/A1_5580.jpg",
      },
    ],
    image: "/images/A1_5399.jpg",
    sizeHeaders: ["サイズ", "着丈 (cm)", "身幅 (cm)", "アームホール (cm)", "体重目安 (kg)"],
    sizeRows: [
      ["S", "63", "40", "46", "50〜60"],
      ["M", "66", "42", "48", "60〜70"],
      ["L", "69", "44", "50", "70〜80"],
      ["XL", "71", "45", "52", "80〜90"],
      ["XXL", "73", "47", "54", "90〜100"],
    ],
    sizeNote: "体重目安は標準体型を基準。筋量多め・肩幅広めの方は1サイズアップを推奨。",
  },
  {
    id: "PWGCDBJJ04C",
    slug: "fight-shorts",
    shopUrl: "https://carpediembjj.store/products/phg-cdbjj-fight-shorts",
    name: "PHG x CDBJJ FIGHT SHORTS",
    category: "FIGHT SHORTS",
    price: 9800,
    material: "ポリエステル95% / スパンデックス5%",
    tagline: "デラヒーバからベリンボロまで、哲学は身体の動きに宿る。",
    description:
      "more than jiu-jitsu — Live the Discipline Active Collection。\nデラヒーバ、ラバーガード、ベリンボロ──股関節の限界まで要求するポジションに、素材が追従する。ポリエステル95%/スパンデックス5%の4ウェイストレッチが下半身のあらゆる動作を妨げず、ウェスト約15cmのアジャスト幅が試合当日の体重変動にも対応する。裾スリットが引き込み動作を解放し、技の精度だけが残る。\n\nCarpe Diem──今この瞬間の一本に、すべてを賭ける。",
    features: ["4ウェイストレッチ", "ウェストアジャスト±15cm", "裾スリット設計", "試合・道場対応"],
    colors: [
      {
        label: "BLACK",
        image: "/images/5.jpg",
      },
      {
        label: "GRAY",
        image: "/images/10.png",
      },
    ],
    image: "/images/5.jpg",
    sizeHeaders: ["サイズ", "ウェスト調整範囲 (cm)", "着丈 (cm)", "股下 (cm)", "体重目安 (kg)"],
    sizeRows: [
      ["S", "67〜82", "40.5", "14.5", "50〜60"],
      ["M", "72〜87", "41.5", "15", "60〜70"],
      ["L", "77〜92", "43", "16", "70〜80"],
      ["XL", "82〜97", "45", "16.5", "80〜90"],
      ["XXL", "87〜102", "46.5", "17", "90〜100"],
    ],
    sizeNote: "ウェスト数値はドローコードによるアジャスト対応範囲。体重目安は標準体型を基準としています。",
  },
  {
    id: "PWGCDBJJ01C",
    slug: "tee",
    shopUrl: "https://carpediembjj.store/products/pwg-cdbjj-wide-tee",
    name: "PHG x CDBJJ WIDE TEE",
    category: "T-SHIRT",
    price: 6000,
    material: "綿100% / 5.6oz / セミコーマ糸",
    tagline: "Carpe Diem. — 今を生きる者のための一枚。",
    description:
      "Carpe Diem.\n— 今を生きる者のための一枚。\n\nCarpe Diem BJJ × Power House Gym Live the Discipline Active Collectionの限定コラボレーションコットンTシャツ。フロント左胸にCarpe Diem BJJのサークルロゴ、右胸にPower House Gymのダイヤモンドロゴ。バックにはPOWER HOUSE GYMのアーチ文字を冠に、ダンベルカールをする鍛え抜かれた男の上半身をハイコントラストで刻む。輪郭を際立たせたグラフィックは、道場で積み重ねた鍛錬が身体に彫り込んだ証を視覚化する。\n\nビッグシルエット設計で、柔術で鍛え抜いた肩や背中でも窮屈さなく着こなせる。5.6ozセミコーマ糸のコットンが落ち感と肌なじみを両立し、スパーリング後の道場でもそのまま街に出られる質感を持つ。\n\nCarpe Diem──道場でも街でも、今を生きる者のための特別な装い。",
    features: ["ビッグシルエット", "コラボグラフィック", "5.6ozセミコーマ糸", "道場〜街まで対応"],
    colors: null,
    image: "/images/A1_5576.jpg",
    sizeNote: "サイズ感に不安がある場合はお問い合わせください。",
    sizeHeaders: ["サイズ", "着丈 (cm)", "身幅 (cm)", "肩幅 (cm)", "袖丈 (cm)"],
    sizeRows: [
      ["S", "66", "55", "52", "21"],
      ["M", "70", "58", "55", "23"],
      ["L", "74", "61", "58", "25"],
      ["XL", "78", "64", "61", "27"],
    ],
  },
];
